export const LISTING_FIELDS = {
  mode: 'mode',
  onlineMeeting: 'onlineMeeting',
  listingOnSchoolBehalf: 'listingOnSchoolBehalf',
  customer_discount: 'customer_discount',
  visibility: 'visibility',
};

export const LISTING_FIELD_MODE = {
  online: 'online',
  inPerson: 'inPerson',
};

/** Hosted mode is a string or a multi-enum array. */
export const listingHasOnlineMode = listingOrMode => {
  const mode =
    listingOrMode && typeof listingOrMode === 'object' && listingOrMode.attributes
      ? listingOrMode.attributes.publicData?.mode
      : listingOrMode;
  if (Array.isArray(mode)) {
    return mode.includes(LISTING_FIELD_MODE.online);
  }
  return mode === LISTING_FIELD_MODE.online;
};

export const getModeLabel = (option, config, intl) => {
  const listingFields = config?.listing?.listingFields;
  const modeField = listingFields?.find(filed => filed.key === LISTING_FIELDS.mode);
  const matchedOption = modeField?.enumOptions?.find(i => i.option === option);
  const fallback = matchedOption ? matchedOption.label : '';

  if (intl && option) {
    return intl.formatMessage({
      id: `Mode.${option}`,
      defaultMessage: fallback || option,
    });
  }

  return fallback || 'ERROR: MODE_LABEL_NOT_FOUND';
};

export const isListingOnSchoolBehalf = listing => {
  return listing?.attributes?.publicData?.[LISTING_FIELDS.listingOnSchoolBehalf] === true;
};
